export default function FacilityCheckboxIcon({ width = 12, height = 12, ...props }: React.SVGProps<SVGSVGElement>) {
  return (
    <svg width={width} height={height} viewBox='0 0 12 12' fill='none' xmlns='http://www.w3.org/2000/svg' {...props}>
      <rect x='0.25' y='0.25' width='11.5' height='11.5' rx='1.75' stroke='#021320' strokeWidth='0.5' />
    </svg>
  );
}
